import { useState } from "react";
import { BellRing, BellOff } from "lucide-react";
import { Input } from "@/components/ui/input";

export const REMINDER_PRESETS = [
  { value: 0, label: "Alla scadenza" }, { value: 15, label: "15 min prima" }, { value: 30, label: "30 min prima" },
  { value: 60, label: "1 ora prima" }, { value: 120, label: "2 ore prima" }, { value: 1440, label: "1 giorno prima" }, { value: 2880, label: "2 giorni prima" },
];

export function offsetLabel(m) {
  const p = REMINDER_PRESETS.find((x) => x.value === m);
  if (p) return p.label;
  if (m % 1440 === 0) return `${m / 1440} giorni prima`;
  if (m % 60 === 0) return `${m / 60} ore prima`;
  return `${m} min prima`;
}

// value: undefined/null = usa predefinito impostazioni; [] = nessun reminder; [n,...] = personalizzato
export default function ReminderPicker({ value, onChange, defaults = [1440, 0], testid = "reminder-picker" }) {
  const [custom, setCustom] = useState("");
  const [customUnit, setCustomUnit] = useState(60);
  const isDefault = value === undefined || value === null;
  const list = isDefault ? defaults : value;
  const none = !isDefault && list.length === 0;
  const toggle = (m) => {
    const base = isDefault ? [...defaults] : [...list];
    const next = base.includes(m) ? base.filter((x) => x !== m) : [...base, m];
    onChange(next.sort((a, b) => b - a));
  };
  const addCustom = () => {
    const n = parseInt(custom, 10);
    if (!n || n <= 0) return;
    toggle(n * customUnit); setCustom("");
  };
  return (
    <div data-testid={testid} className="rounded-lg border border-slate-200 p-3 bg-slate-50/60 space-y-2.5">
      <div className="flex flex-wrap gap-1.5">
        <button type="button" data-testid={`${testid}-none`} onClick={() => onChange([])}
          className={`inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs border transition-colors ${none ? "bg-slate-800 text-white border-slate-800" : "bg-white text-slate-600 border-slate-200 hover:border-slate-400"}`}>
          <BellOff className="w-3 h-3" /> Nessun reminder
        </button>
        {REMINDER_PRESETS.map((p) => {
          const on = !none && list.includes(p.value);
          return (
            <button key={p.value} type="button" data-testid={`${testid}-opt-${p.value}`} onClick={() => toggle(p.value)}
              className={`px-2.5 py-1 rounded-full text-xs border transition-colors ${on ? "bg-teal-600 text-white border-teal-600" : "bg-white text-slate-600 border-slate-200 hover:border-teal-400"}`}>
              {p.label}
            </button>
          );
        })}
        {!none && list.filter((m) => !REMINDER_PRESETS.some((p) => p.value === m)).map((m) => (
          <button key={m} type="button" data-testid={`${testid}-opt-${m}`} onClick={() => toggle(m)} className="px-2.5 py-1 rounded-full text-xs border bg-teal-600 text-white border-teal-600">{offsetLabel(m)} ×</button>
        ))}
      </div>
      <div className="flex items-center gap-2">
        <span className="text-xs text-slate-500">Personalizzato:</span>
        <Input data-testid={`${testid}-custom-value`} type="number" min={1} value={custom} onChange={(e) => setCustom(e.target.value)} className="h-8 w-20" placeholder="es. 3" />
        <select data-testid={`${testid}-custom-unit`} value={customUnit} onChange={(e) => setCustomUnit(parseInt(e.target.value, 10))} className="h-8 rounded-md border border-slate-200 bg-white text-xs px-2">
          <option value={1}>minuti prima</option><option value={60}>ore prima</option><option value={1440}>giorni prima</option>
        </select>
        <button type="button" data-testid={`${testid}-custom-add`} onClick={addCustom} className="h-8 px-2.5 rounded-md bg-navy-900 text-white text-xs">Aggiungi</button>
        {isDefault && <span className="ml-auto inline-flex items-center gap-1 text-[11px] text-teal-700"><BellRing className="w-3 h-3" /> Predefinito da Impostazioni</span>}
      </div>
    </div>
  );
}
